import { sectionsMapper } from '../../../constants/routes';
import { HEADER_OFFSET_SCROLL } from '../../../constants';

export const DATA_AS_NAV_TAB_ATTR = 'data-as-nav-tab';

type TabConfiguration = {
  title: string;
  anchor: string;
  point: number;
};

export function mapClausesToTabs(clauses: HTMLElement[]): TabConfiguration[] {
  if (clauses.length < 1) {
    return [];
  }

  return clauses
    .reduce((acc, tabElement) => {
      const anchor = tabElement.getAttribute('id');

      if (anchor) {
        const title = tabElement.getAttribute(DATA_AS_NAV_TAB_ATTR) || sectionsMapper[anchor];

        if (title) {
          acc.push({
            title,
            anchor,
            point: tabElement.offsetTop - HEADER_OFFSET_SCROLL,
          });
        }
      }

      return acc;
    }, Array.of<TabConfiguration>())
    .sort((a, b) => a.point - b.point);
}
